import { raf } from '@rc-component/util';
function throttleByAnimationFrame(fn) {
    let requestId = null;
    const later = (args) => () => {
        requestId = null;
        fn(...args);
    };
    const throttled = (...args) => {
        if (requestId === null) {
            requestId = raf(later(args));
        }
    };
    throttled.cancel = () => {
        raf.cancel(requestId);
        requestId = null;
    };
    return throttled;
}
export default throttleByAnimationFrame;
